import {
  ADD_MEDIA,
  ADD_MEDIAS
} from '../actions/actions_media'

const media = (state = {
  uploaded : [],
  defaults : [],
  maki : [],
  mapkey : []
}, action) => {
  switch (action.type) {
    case ADD_MEDIA:
      var newState = JSON.parse(JSON.stringify(state));
      newState[action.payload.meta.wp_mapbox_gl_js_media[0]].push(action.payload);
      return newState;
    case ADD_MEDIAS:
      var newState = JSON.parse(JSON.stringify(state));
      var ids = [];
      for (var type in newState) {
        newState[type].forEach(function(thisMedia) {
          ids.push(thisMedia.id);
        })
      }
      action.payload.uploaded.forEach(function(thisMedia) {
        if(ids.indexOf(thisMedia.id)===-1) {
          newState.uploaded.push(thisMedia);
        }
      })
      action.payload.defaults.forEach(function(thisMedia) {
        if(ids.indexOf(thisMedia.id)===-1) {
          newState.defaults.push(thisMedia);
        }
      })
      action.payload.maki.forEach(function(thisMedia) {
        if(ids.indexOf(thisMedia.id)===-1) {
          newState.maki.push(thisMedia);
        }
      })
      action.payload.mapkey.forEach(function(thisMedia) {
        if(ids.indexOf(thisMedia.id)===-1) {
          newState.mapkey.push(thisMedia);
        }
      })
      return newState;
    default:
      return state
  }
}

export default media



// WEBPACK FOOTER //
// ./src/reducers/reducer_media.js